<template>
  <div>
    <van-nav-bar
      title="入库查询"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />


    <van-overlay :show="searchshow" :lock-scroll="false" >

      <div style="width: 90%; height: 90%;margin:0 auto;background-color: aliceblue; position: absolute;top: 5%;left: 5%; overflow-y: auto; overflow-x: hidden;-webkit-overflow-scrolling: touch;" >
         <van-sticky>
          <van-search show-action v-model="pdvalue" placeholder="请输入搜索关键词" @search="searchproducts"     @cancel="searchshow=false" />
         </van-sticky>
          <van-swipe-cell v-for="item in pdlist" :key="item.id">

            <van-cell :title="item.name"  :value="'库存：'+item.remaining_count" :label="'价格线：'+item.price_line" />
            <template #right>
              <van-button square type="primary" text="选择" style="height: 100%;" @click="selectpd(item)"/>
            </template>
          </van-swipe-cell>



      </div>

    </van-overlay>
    <van-overlay :show="factoryshow" :lock-scroll="false" >

      <div style="width: 90%; height: 90%;margin:0 auto;background-color: aliceblue; position: absolute;top: 5%;left: 5%; overflow-y: auto; overflow-x: hidden;-webkit-overflow-scrolling: touch;" >
         <van-sticky>
          <van-search show-action v-model="factoryvalue" placeholder="请输入搜索关键词" @search="searchfactory"     @cancel="factoryshow=false" />
         </van-sticky>
          <van-swipe-cell v-for="item in factorylist" :key="item.id">

            <van-cell :title="item.name"  />
            <template #right>
              <van-button square type="primary" text="选择" style="height: 100%;" @click="selectfactory(item)"/>
            </template>
          </van-swipe-cell>



      </div>

    </van-overlay>

    <van-form @submit="onSubmit">

      <van-field
        v-model="pdname"
        name="产品"
        label="产品"
        placeholder="产品名称"
        readonly
        @click="searchshow=true"
        :rules="[{ required: true, message: '请选择产品' }]"
      />
      <van-field
        v-model="danwei"
        name="单位"
        label="单位"
        placeholder="单位"
        readonly

      />
      <van-field name="radio" label="类型" :rules="[{ required: true, message: '请选择类型' }]">
        <template #input>
          <van-radio-group v-model="form.type" direction="horizontal">
            <van-radio name="0">采购订单</van-radio>
            <van-radio name="1">销售退单</van-radio>
            <van-radio name="2">调货入库</van-radio>
            <van-radio name="3">库存调度</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="picker"
        :value="ckname"
        label="仓库"
        placeholder="点击选择仓库"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择仓库' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="cangkulist"
          @confirm="selcangku"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        v-model="factoryname"
        name="厂商"
        label="厂商"
        placeholder="厂商名称"
        readonly
        @click="factoryshow=true"
        :rules="[{ required: true, message: '请选择厂商' }]"
      />
      <van-field v-model="form.total_count" type="digit" label="数量"  @change="compprice" :rules="[{ required: true, message: '请输入数量' }]"/>


      <van-field v-model="form.cost_unit" type="number" label="单价" @change="compprice" :rules="[{ required: true, message: '请输入成本单价' }]"/>
      <van-field v-model="form.cost_total" type="number" label="总价"  @change="compunit" :rules="[{ required: true, message: '请输入成本总价' }]"/>



      <van-field
        v-model="form.description"
        rows="4"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入备注"

      />



      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>



  </div>
</template>

<script>
import * as Api from './api.js'
import { Toast } from 'vant';
  export default {
    name: 'RukuList',
    data () {
      return {

        searchshow:false,
        pdvalue:'',
        pdlist:[],
        pdname:'',
        form:{
          type:'',
          cangku:'',
          factory:'',
          total_count:1,
          cost_unit:0,
          cost_total:0,
          product:'',
          description:'',
          team:1
        },
        showPicker:false,
        cangkulist:[],
        ckname:'',
        factoryshow:false,
        factorylist:[],
        factoryvalue:'',
        factoryname:'',
        danwei:'',


      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.getcangkudata()

    },
    methods:{
      getcangkudata(){
        let query={
          limit:999
        }
        Api.getcangku(query).then(res=>{
          this.cangkulist = res.data.data
        })
      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },


      searchproducts(){
        let query={
          limit:999,
          name:this.pdvalue
        }

        Api.getproducts(query).then(res=>{
          this.pdlist = res.data.data
        })
      },
      selectpd(item){
        this.form.product = item.id
        this.pdname = item.name
        this.danwei =item.danwei
        this.form.cost_unit = item.avg_cost_unit
        this.compprice()
        this.searchshow = false

      },
      onSubmit(){
        console.log(this.form)
        Api.add(this.form).then(res=>{
          console.log(res)
          Toast(res.msg)


        })
      },
      selcangku(cangkuitem){

        this.form.cangku = cangkuitem.id
        this.ckname = cangkuitem.name
        this.showPicker = false
      },
      searchfactory(){
        let query={
          limit:999,
          name:this.factoryvalue
        }

        Api.getfactory(query).then(res=>{
          this.factorylist = res.data.data
        })

      },
      selectfactory(item){
        this.form.factory = item.id
        this.factoryname = item.name
        this.factoryshow = false
      },
      compprice(){
        this.form.cost_total = this.form.cost_unit * this.form.total_count
      },
      compunit(){
        this.form.cost_unit = this.form.cost_total  / this.form.total_count
      }

    }
  }

</script>

<style>
  .celllabel{
    width:100%
  }
</style>



// WEBPACK FOOTER //
// src/views/shangwuviews/rukuadd/index.vue